import React from "react";
import Link from "components/link";
import Image from "components/image";
import SocialMedia from "components/social-media";
import Newsletter from "components/newsletter";
import { ReactComponent as LocationIcon } from "assets/svgs/location.svg";

const ContactInfo = ({ contactInfo }) => (
	<div className="flex flex-col gap-1">
		{contactInfo.map((info) => (
			<div className="flex gap-2 items-start" key={info._key}>
				<div className="min-w-4 w-4 flex pt-1">
					<Image image={info.icon} />
				</div>
				<Link to={info.icon?.url} className="text-tertiary text-base">
					{info.text}
				</Link>
			</div>
		))}
	</div>
);

const GroupLinks = ({ groupLinks }) => (
	groupLinks.map((group) => (
		<div key={group._key} className="flex flex-col gap-2 mb-4 md:mb-0 min-w-fit w-1/2 lg:w-auto">
			<p className="font-semibold text-xl mb-3">{group.title}</p>
			{group.links.map((link) => (
				<Link to={link.url} key={link._key} className="text-tertiary">{link.title}</Link>
			))}
		</div>
	))
);

const AppDownload = ({ appDownload }) => (
	<div className="flex flex-col gap-5 w-1/2 lg:w-auto">
		<p className="font-semibold text-xl">{appDownload.label}</p>
		<div className="flex flex-col gap-4">
			{appDownload.links.map((app, index) => (
				<div key={index}>
					<Image className="max-w-44" image={app.icon} width={180} />
				</div>
			))}
		</div>
	</div>
);

const PaymentIcons = ({ paymentIcons }) => (
	paymentIcons.map((icon) => (
		<div key={icon._key} className="w-20 h-8 border px-2 py-1 flex items-center">
			<Image image={icon} alt={icon.alt} className="w-full h-full" />
		</div>
	))
);

const Footer = ({ sliceContext, previewData, pageSettings }) => {
	const { links, individualLinks, appDownload, logo, paymentIcons, contactInfo, newsletter } = previewData || sliceContext;

	if (pageSettings?.minimalFooter) {
		return (
			<footer>
				<div className="footer-container py-20">
					<div className="w-full flex-center flex-col gap-14">
						<Image image={{ ...logo, url: "" }} width={120} />
						<div className="flex-center flex-col gap-12">
							{individualLinks?.length > 0 &&
								<div className="flex gap-6">
									{individualLinks.map((link) => <Link to={link.url} key={link._key}
										className="text-nowrap underline">{link.title}</Link>)}
								</div>}
							<div className="flex gap-3">
								<LocationIcon />
								<p className="flex font-bold gap-1 text-sm md:text-lg">
									<span>Location:</span>
									<span>2251 Constitution Ave, Olean, NY 14760</span>
								</p>
							</div>
						</div>
					</div>
				</div>
				<div className="footer-payments !py-5">
					<p className="text-center py-2 text-secondary text-nowrap">© {new Date().getFullYear()}, MOD LIGHTING</p>
					<div className="flex justify-center flex-wrap gap-3">
						<PaymentIcons paymentIcons={paymentIcons} />
					</div>
				</div>
			</footer>
		);
	}

	return (
		<footer>
			{!pageSettings?.hideNewsletter && <Newsletter data={newsletter} className="md:py-20" />}
			<div className="footer-container">
				<div className="footer-content">
					<div className="footer-logo">
						<div className="flex">
							<Image image={logo} alt={logo.alt} width={140} />
						</div>
						<ContactInfo contactInfo={contactInfo} />
						<SocialMedia invert className="gap-4" />
					</div>

					<div className="footer-links justify-between gap-y-4 flex-wrap">
						<GroupLinks groupLinks={links} />
						<AppDownload appDownload={appDownload} />
					</div>
				</div>
			</div>
			<div className="footer-payments">
				{individualLinks?.length > 0 &&
					<div className="flex gap-4">
						{individualLinks.map((link) => <Link to={link.url} key={link._key}
							className="text-secondary text-nowrap">{link.title}</Link>)}
					</div>}
				<p className="text-center py-2 text-secondary text-nowrap">© {new Date().getFullYear()}, MOD LIGHTING</p>
				<div className="flex justify-center flex-wrap gap-3">
					<PaymentIcons paymentIcons={paymentIcons} />
				</div>
			</div>
		</footer>
	);
};

export default Footer;
